export const DailyOperationMenu = {
  routes: [
    {
      name: 'daily_operations',
      displayName: 'menu.operation_of_day',
      subject_class: "DailyOperations"
    },
  ]
} 

        

